module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_strengths_img-71a49aaeb6b751a0285d65ac6126e8ed.jpg";